import Brand from "../components/Brand";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import FooterMenu from "../components/FooterMenu";
import FooterBottom from "../components/FooterBottom";

const Layout = ({ children }) => {
  return (
    <div>
      <Brand />
      <Navbar />
      {children} {/* This will render the page content */}
      <Footer />
      <FooterMenu />
      <FooterBottom />
    </div>
  );
};

export default Layout;
